import { isUndefined, omitBy } from 'lodash-es';
const typesafeKeys = (obj) => Object.keys(obj);
const typesafeEntries = (obj) => Object.entries(obj);
const deepFreeze = (obj) => {
    if (typeof obj !== 'object' || obj === null) {
        return obj;
    }
    Object.getOwnPropertyNames(obj).forEach((prop) => deepFreeze(obj[prop]));
    return Object.freeze(obj);
};
const removeUndefined = (input) => omitBy(input, isUndefined);
const sortObject = (input) => {
    if (input) {
        typesafeKeys(input)
            .sort()
            .forEach((key) => {
            const temp = input[key];
            delete input[key];
            input[key] = temp;
        });
    }
};
export { deepFreeze, removeUndefined, sortObject, typesafeEntries, typesafeKeys };
//# sourceMappingURL=objects.js.map